import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-layout" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "container center text-muted" }, null, -1)

import NavHeader from "../components/nav/NavHeader.vue";
import SeComboBox from "../components/global/SeComboBox.vue";

import { defineComponent } from "@vue/runtime-core";

const __default__ = defineComponent({
  methods: {},
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SupportView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NavHeader, { title: "Support" }),
    _hoisted_2
  ]))
}
}

})